var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditClienteVenta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1b1464;}.cls-2{fill:#c2b8b9;}.cls-3{fill:#463836;}.cls-4{fill:#f99d88;}.cls-5{fill:#f14742;}.cls-6{fill:#ffd24d;}.cls-7{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 2905-07-2019") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 35,
    height: 35,
    rx: 3.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.76 13.3 29.46 11.24 27.4 10.93 26.09 12.25 26.39 14.3 28.45 14.61 29.76 13.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.94,26.32a.3.3,0,0,0,0,.43.31.31,0,0,0,.44,0l1.93-1.13.26-1.49-1.49.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "16.7 21.63 15.08 24.39 16.31 25.62 19.06 24 18.76 21.94 16.7 21.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.21,11.85a1.67,1.67,0,0,0-2.37-2.36L27.4,10.93l2.36,2.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 15.94,
    y: 16.45,
    width: 13.27,
    height: 3.34,
    transform: "translate(-6.2 21.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 11.03,
    cy: 26.53,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 7.9,
    cy: 26.53,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 4.77,
    cy: 26.53,
    r: 0.46
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditClienteVenta);
export default __webpack_public_path__ + "static/media/edit-cliente-venta.0dadbec1a9ba87813559c1b594c1a506.svg";
export { ForwardRef as ReactComponent };